import React from 'react';
import { MenuItem, Select, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  root: {
    height: '1rem',
    width: '3.0rem',
    fontSize: '0.75rem'
  },
}));

interface Props {
  value: number,
  maxOtherBag: number,
  onChange: (e: React.ChangeEvent<{
    name?: string | undefined;
    value: unknown;
  }>) => void,
}

/** その他荷物(※車椅子など)の個数選択のコンポーネント。 */
export const SelectOtherBag: React.FC<Props> = (props: Props) => {
  const classes = useStyles();
  /** その他荷物(※車椅子など)の個数（0~Xまでの数値）の値の配列。 */
  const numbers = Array.from(Array(props.maxOtherBag+1).keys())

  return (
    <Select
      className={classes.root}
      SelectDisplayProps={{
        style: {
          padding: '10px'
        }
      }}
      onChange={props.onChange}
      value={props.value}
    >
      {
        numbers.map((n) => {
          return <MenuItem value={n} key={`otherbag_${n}`}>{n}</MenuItem>
        })
      }
    </Select>
  );
}

export default SelectOtherBag;
